import {Component, OnInit, ChangeDetectorRef, ViewChild, ViewContainerRef, OnDestroy} from '@angular/core';
import {IWorkflowStepComponent} from '@shared/interfaces/workflow-step.interface';
import {WorkflowModel, WorkflowState} from '../../../../workflow/models/workflow.model';
import {Observable, Subject} from 'rxjs';
import {take, takeUntil} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';
import {Guid} from 'guid-typescript';
import {getCurrentSurvey} from '../../../store/selectors/data-survey.selectors';
import {DialogService} from '@shared/services/dialog-service';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {WorkflowWizardComponent} from '../../../../workflow/components/workflow-wizard/workflow-wizard.component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {DataSurveyState} from '../../../store/reducers/data-survey.reducers';
import {GetSurveyAction} from '../../../store/actions/data-survey.actions';
import {QueryModel} from '@shared/models/query-model';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {QueryProvider} from '@shared/queries/query-provider';
import {getQueryResponse} from '@shared/store/selectors/query.selector';

@Component({
    standalone: false,
    selector: 'particle-select-data-step',
  templateUrl: './select-data-step.component.html',
  styleUrls: ['./select-data-step.component.scss']
})
export class SelectDataStepComponent implements OnInit, OnDestroy, IWorkflowStepComponent {
  workflow: WorkflowModel;
  currentStep: WorkflowState;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  genericReportByIdKey = 'GenericReportById';
  queryModels: QueryModel[] = [];
  response$: Observable<any>;
  report: any;
  isReportSectionReady: boolean = false;
  selectedFieldSectionIndex: any;
  selectedSection: any;
  wizard: any;
  dataExecutionId: any;
  dataSelectionIds: any;
  invalidateSubjectList: InvalidateSubject[] = [];
  noOfSections = 10;
  hasTabs: boolean;
  reportId: any;

  ngOnInit() {

  }

  onTabIndexChange(event) {
    this.selectedFieldSectionIndex = event;
    this.selectedSection = this.report.dataSections[event];
    if (this.wizard.isWorkflowInLastState) {
      this.wizard.nextButtonCaption = this.selectedFieldSectionIndex === (this.report.dataSections.length - 1) ? 'Finish' : 'Next';
    }
  }

  onGridCellValueChange(event) {
    console.log('for build purpose');
  }

  onLoad(workflow: WorkflowModel, currentStep: WorkflowState) {
    this.workflow = workflow;
    this.currentStep = currentStep;
    const reportIdInput = workflow.States[0].Inputs.find(o => o.Name === 'ReportId');
    if (reportIdInput) {
      this.reportId = reportIdInput.Value;
      this.queryModels.push(QueryProvider.getQuery(this.genericReportByIdKey));
      this.response$ = this.queryStore.pipe(select(getQueryResponse, this.genericReportByIdKey));
      this.response$.pipe(take(2)).subscribe(report => {
        if (!this.isReportSectionReady && report && report.dataSections) {
          if (report.dataSections.length) {
            if (!this.dataExecutionId) {
              this.report = report;
              const reportTaskInput = this.currentStep.Inputs.find(o => o.Name === 'ReportTaskId');

              this.dataExecutionId = reportTaskInput.Value;
              this.dataSelectionIds = {};
              this.report.dataSections.forEach(f => {
                f.config['EXECUTION_ID'] = this.dataExecutionId + f.config['SourceType'].toLowerCase();
                this.dataSelectionIds[f.sectionId] = f.config['EXECUTION_ID'];
              });
              this.isReportSectionReady = true;
              this.onTabIndexChange(0);
            }
          }
        }
        console.log('Report', this.report);
      });
      QueryProvider.invokeQuery(this.queryStore, this.genericReportByIdKey, {'[Id]': this.reportId});
    }
  }

  canMoveNext$(): Observable<boolean> {
    return null;
  }

  canMoveNext(): boolean {
    if (!this.report.dataSections) {
      return true;
    }
    if (!this.dataSelectionIds || this.dataSelectionIds.length === 0) {
      return true;
    }
    if (this.selectedFieldSectionIndex < this.report.dataSections.length - 1) {
      this.selectedFieldSectionIndex++;
      this.onTabIndexChange(this.selectedFieldSectionIndex);
      return false;
    }
    const filterInput = this.currentStep.Inputs.find(o => o.Name === 'Filters');
    if (filterInput && !filterInput.Arguments) {
      filterInput.Arguments = {};
    }
    Object.keys(this.dataSelectionIds).forEach(key => {
      filterInput.Arguments[key] = this.dataSelectionIds[key];
    });

    return true;
  }

  canCancel(): boolean {
    return true;
  }


  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  constructor(public changeDetectorRef: ChangeDetectorRef, private dialogService: DialogService,
              private commandService: CommandService,
              private snackBarService: SnackBarService,
              private queryStore: Store<IQueryState>) {
    for (let i = 0; i <= this.noOfSections; i++) {
      this.invalidateSubjectList = [...this.invalidateSubjectList, new InvalidateSubject()];
    }
  }

  getNextButtonCaption(isFinished: boolean): string {
    return isFinished && this.canMoveNext() ? 'Finish' : 'Next';
  }

  setWizard(wizard: WorkflowWizardComponent) {
    this.wizard = wizard;
  }

  onFieldSectionChanged($event: any) {
    console.log('onFieldSectionChanged at step', $event);
    this.hasTabs = $event && $event.length > 1;
    if (this.wizard) {
      this.wizard.hasTabs = this.hasTabs;
      console.log('Has Tabs', this.wizard.hasTabs);
    }
  }


}
